import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'

import Header from '../../components/Header'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'

import _ from 'lodash'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  container: {
    margin: '16px',
    overflowY: 'auto',
    height: '100%',
  },
  agreeContent: {
    ...fontDefault,
    color: '#999999',
    fontSize: '14px',
  },
  agreeContentHead: {
    ...fontDefault,
    color: '#999999',
    fontSize: '14px',
    fontWeight: 'bold',
    margin: '0px',
  },
  numberContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  number: {
    ...fontDefault,
    fontSize: '14px',
    marginRight: '8px',
    color: '#999999',
  },
  numberText: {
    ...fontDefault,
    color: '#999999',
    fontSize: '14px',
  },
  flexSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  fullWidth: {
    width: '100%',
  },
  widthDivider: {
    width: '16px',
    display: 'block',
  },
  head: {
    ...fontDefault,
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0px',
  },
  numberContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  number: {
    ...fontDefault,
    fontSize: '14px',
    marginRight: '8px',
    color: '#999999',
  },
  numberText: {
    ...fontDefault,
    color: '#999999',
    fontSize: '14px',
  },
  flexSpace: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  fullWidth: {
    width: '100%',
  },
  widthDivider: {
    width: '16px',
    display: 'block',
  },
  head: {
    ...fontDefault,
    fontSize: '16px',
    fontWeight: 'bold',
  },
}

class Agreement extends Component {
  state = {
    modalVisible: false,
  }

  readPolicy = () => {
    this.setState({
      modalVisible: true,
    })
  }

  goToNextPage = () => {
    const {
      history: { push },
      setUserInput,
    } = this.props
    setUserInput({
      isAgree: true,
    })
    push('/summary')
    //setTimeout(() => {
    //  window.scrollTo(0, document.body.scrollHeight);
    //}, 50);
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/summary')
    //setTimeout(() => {
    //  window.scrollTo(0, document.body.scrollHeight);
    //}, 50);
  }

  render() {
    const { classes, currentProduct } = this.props
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              ข้อกำหนดและเงื่อนไข
            </Typography>
          </TopBar>
        </Header>

        <div
          style={{
            backgroundColor: '#eff0f4',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            marginTop: '50px',
          }}
        >
          {currentProduct === 'V' ? (
            <div className={classes.container}>
              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคสมัครใจ
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจได้เพียง 1
                  ฉบับต่อรถยนต์ 1 คัน
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รับประกันภัยรถยนต์นั่งและรถกระบะส่วนบุคคล
                  ไม่ใช้รับจ้างหรือให้เช่า
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รับประกันภัยอายุรถยนต์ 2-15 ปี
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  คุ้มครองอุปกรณ์ตกแต่งที่ติดตั้งมากับตัวรถโดยโรงงานประกอบรถยนต์เท่านั้น
                  ไม่รวมถึงอุปกรณ์ตกแต่งเพิ่มเติม
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                  การเสนอขายประกันภัยโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไขและหลักเกณฑ์ของบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                </Typography>
              </div>

              <br />
              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัย พ.ร.บ สำหรับรถยนต์นั่งส่วนบุคคลไม่เกิน 7
                  ที่นั่ง และรถยนต์บรรทุกส่วนบุคคล ไม่เกิน 3 ตัน เท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อ พ.ร.บ ได้เพียง 1 ฉบับต่อรถยนต์ 1
                  คัน
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                  การเสนอขายประกันภัยทำโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไข
                  และหลักเกณฑ์ของบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                </Typography>
              </div>

              <br />
              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รับเงินคืน 15% ของค่าเบี้ยประกันภัย
                  เมื่อซื้อประกันภัยรถยนต์ภาคสมัครใจของกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                  TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                  ตั้งแต่ 1 ตุลาคม 2562 – 15 ธันวาคม 2564
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                  (“บริษัท”)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืน 15%
                  จะคำนวณจากค่าเบี้ยประกันภัยรถยนต์ภาคสมัครใจอัตราสุทธิ
                  ที่ไม่รวมภาษีมูลค่าเพิ่มและอากรแสตมป์
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                  ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                  วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                  และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                  รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                  หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                  หรือมีการบอกเลิกสัญญา
                  หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                  บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                  TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                  การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                  รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย
                  จำกัด (มหาชน)
                  แต่เพียงฝ่ายเดียวบริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                  วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                  รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                  การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                  โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                  คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                  บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                  และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                  หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                  เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                  สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                  Call Center โทร.1240
                </Typography>
              </div>

              <br />
              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รับเงินคืนสูงสุดถึง 200 บาท เมื่อซื้อประกันภัยรถยนต์ภาคบังคับ
                  (พ.ร.บ.)
                  กับกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                  TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                  ตั้งแต่ 1 ตุลาคม 2562 – 15 ธันวาคม 2564
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                  (“บริษัท”)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทจะให้เงินคืนโดยโอนเข้าบัญชี TrueMoney Wallet
                  ตามรายละเอียดอัตราดังต่อไปนี้
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 200 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถตู้นั่งส่วนบุคคลไม่เกิน 12 ที่นั่ง (ค่าเบี้ยประกันภัย
                  1,182.35 บาท) หรือ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 160 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถกระบะบรรทุกส่วนบุคคลไม่เกิน 4 ตัน (ค่าเบี้ยประกันภัย
                  967.28 บาท) หรือ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 100 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถยนต์ส่วนบุคคลไม่เกิน 7 ที่นั่ง (ค่าเบี้ยประกันภัย
                  645.21 บาท)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  จำกัดสิทธิ์ในการได้รับเงินคืนไม่เกิน 10 ครั้งต่อ 1
                  หมายเลขบัตรประชาชนต่อเดือน
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                  ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                  วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                  และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                  รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                  หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                  หรือมีการบอกเลิกสัญญา
                  หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                  บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                  TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                  การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                  รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย
                  จำกัด (มหาชน) แต่เพียงฝ่ายเดียว
                  บริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                  วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                  รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                  การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                  โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                  คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                  บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                  และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                  หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                  เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                  สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                  Call Center โทร.1240
                </Typography>
              </div>
            </div>
          ) : (
            <div className={classes.container}>
              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัย พ.ร.บ สำหรับรถยนต์นั่งส่วนบุคคลไม่เกิน 7
                  ที่นั่ง และรถยนต์บรรทุกส่วนบุคคล ไม่เกิน 3 ตัน เท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อ พ.ร.บ ได้เพียง 1 ฉบับต่อรถยนต์ 1
                  คัน
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                  การเสนอขายประกันภัยทำโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไข
                  และหลักเกณฑ์ของบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                </Typography>
              </div>

              <br />
              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <br />

              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รับเงินคืนสูงสุดถึง 200 บาท เมื่อซื้อประกันภัยรถยนต์ภาคบังคับ
                  (พ.ร.บ.)
                  กับกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                  TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                  ตั้งแต่ 1 ตุลาคม 2562 – 31 ธันวาคม 2564
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                  (“บริษัท”)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทจะให้เงินคืนโดยโอนเข้าบัญชี TrueMoney Wallet
                  ตามรายละเอียดอัตราดังต่อไปนี้
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 200 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถตู้นั่งส่วนบุคคลไม่เกิน 12 ที่นั่ง (ค่าเบี้ยประกันภัย
                  1,182.35 บาท) หรือ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 160 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถกระบะบรรทุกส่วนบุคคลไม่เกิน 4 ตัน (ค่าเบี้ยประกันภัย
                  967.28 บาท) หรือ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนจำนวน 100 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                  ประเภทรถยนต์ส่วนบุคคลไม่เกิน 7 ที่นั่ง (ค่าเบี้ยประกันภัย
                  645.21 บาท)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  จำกัดสิทธิ์ในการได้รับเงินคืนไม่เกิน 10 ครั้งต่อ 1
                  หมายเลขบัตรประชาชนต่อเดือน
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                  ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                  วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                  และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน)
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                  รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                  หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                  หรือมีการบอกเลิกสัญญา
                  หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                  บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                  TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                  การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                  รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย
                  จำกัด (มหาชน) แต่เพียงฝ่ายเดียว
                  บริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                  วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                  รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                  การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                  โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                  คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                  บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                  และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                  หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                  เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                  ก่อนตัดสินใจทำประกันภัย
                  สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                  กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
                </Typography>
              </div>
              <div className={classes.numberContainer}>
                <Typography className={classes.number}>•</Typography>
                <Typography className={classes.numberText}>
                  สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                  Call Center โทร.1240
                </Typography>
              </div>
            </div>
          )}
          <SubmitButton onClick={this.goToNextPage}>
            ยอมรับเงื่อนไข
          </SubmitButton>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Agreement))
